import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

import '@/App.css';
import { AuthProvider, useAuth } from '@/auth/AuthContext';
import Layout from '@/components/Layout';
import { Toaster } from '@/components/ui/sonner';
import Agenda from '@/pages/Agenda';
import Caja from '@/pages/Caja';
import Clientes from '@/pages/Clientes';
import Gastos from '@/pages/Gastos';
import Login from '@/pages/Login';
import Reporte from '@/pages/Reporte';
import Stock from '@/pages/Stock';
import Ventas from '@/pages/Ventas';

function Routing() {
  const { isAuthenticated, loading } = useAuth();

  // Mientras revalidamos el token guardado, no mostramos ni login ni la app:
  // así se evita el parpadeo del login en cada recarga.
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 size={28} className="animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Reporte />} />
        <Route path="/ventas" element={<Ventas />} />
        <Route path="/stock" element={<Stock />} />
        <Route path="/caja" element={<Caja />} />
        <Route path="/gastos" element={<Gastos />} />
        <Route path="/clientes" element={<Clientes />} />
        <Route path="/agenda" element={<Agenda />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routing />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}
